export default {
	NO_DATA: 'No data to show',
	TITLE: 'Bundle rule visualization',
};
